import {useStyles} from '../../../../../shared/hooks/styles';

export const useTruItemStyles = () => {
  return useStyles(({theme}) => ({
    truItem: {
      padding: 16,
      width: '100%',
    },
    innerContainer: {
      paddingBottom: 24,
      borderBottomWidth: 1,
      borderBottomColor: theme.color.borderColor,
    },
    truName: {
      ...theme.fonts.body,
      flex: 1,
      flexShrink: 1,
    },
    row: {
      flexDirection: 'row',
      width: '100%',
    },
    icon: {
      marginRight: 8,
      justifyContent: 'center',
      height: 24,
    },
    label: {
      width: '30%',
      marginRight: 8,
      ...theme.fonts.bodySmallLight,
    },
    text: {
      width: '70%',
      ...theme.fonts.bodySmall,
    },
  }));
};
